export const API = {
  BASE_URL: process.env.REACT_APP_BASE_URL || "http://localhost:8500/api/",
  GRAPHQL: process.env.REACT_APP_GRAPHQL_URL || "http://localhost:8500/graphql",

  APP_URL: process.env.REACT_APP_APP_URL || "https://www.suprabhaatham.com/",
  EDITOR_API_KEY: process.env.REACT_APP_EDITOR_API_KEY || "",
  WHATS_APP_LINK: process.env.REACT_APP_WHATSAPP_LINK || "https://chat.whatsapp.com/Ebq27HufM0NHH37t6blQtO",

  CACHE_SERVER_1: process.env.REACT_APP_CACHE_SERVER_1 || "",
  CACHE_SERVER_2: process.env.REACT_APP_CACHE_SERVER_2 || "",
  CACHE_SERVER_3: process.env.REACT_APP_CACHE_SERVER_3 || "",
  CACHE_SERVER_4: process.env.REACT_APP_CACHE_SERVER_4 || "",

  EPAPER_PDF: process.env.REACT_APP_EPAPER_PDF_URL || "https://e-files.suprabhaatham.com/pdf/convert",
  EPAPER_IMAGE: process.env.REACT_APP_EPAPER_IMAGE_URL || "https://e-files.suprabhaatham.com/img/upload",

  // --------- endpoints -------
  // New JWT auth endpoints
  AUTH_LOGIN: "auth/login",
  AUTH_VERIFY_OTP: "auth/verify-otp",
  AUTH_RESEND_OTP: "auth/resend-otp",
  AUTH_REFRESH: "auth/refresh",
  AUTH_LOGOUT: "auth/logout",
  AUTH_LOGOUT_ALL: "auth/logout-all",
  AUTH_ME: "auth/me",
  AUTH_SESSIONS: "auth/sessions",
  AUTH_ADMIN_BLOCK_USER: "auth/admin/block-user/",
  AUTH_ADMIN_UNBLOCK_USER: "auth/admin/unblock-user/",
  AUTH_ADMIN_USER_SESSIONS: "auth/admin/user-sessions/",

  // Legacy endpoints (deprecated — will be removed)
  LOGIN: "userLogin",
  IMAGE_UPLODER: "s3upload",
  NEW_IMAGE_UPLOAD: process.env.REACT_APP_NEW_IMAGE_UPLOAD_URL,
  // || "https://files.suprabhaatham.com/upload",
  UPLOADTO_MEDIALIBRARY: "insertMediaLibrary",
  UPLOADINTOMEDIA: "MediaLibrary",
  VERIFY_OTP: "verifyOTP",
  ADMIN_FORGOT_PASSWORD: "adminForgotPassword",
  ADMIN_VERIFY_RESET_OTP: "adminVerifyResetOTP",
  ADMIN_RESET_PASSWORD: "adminResetPassword",
  REGISTER: "auth/local/register",
  CREATE_USER: "createUser",
  GET_ROLE: "users/me?populate=*",

  ALL_NEWS: "all-news",
  GET_NEWS: "filterNews",
  GET_NEWS_META: "newsMeta",
  REFRESH_CACHE: "api/revalidate?path=details/",
  // One path covers every /todaysarticle?id=… page: the website tags its cached
  // CMS queries by pathname (query string excluded).
  REFRESH_ARTICLE_CACHE: "api/revalidate?path=todaysarticle",

  GET_USERS_LIST: "filterUsers",
  EXPORT_USER_DATA: "ExportLog",
  PUBLISH_NEWS: "publish",
  EDITORIALS: "editorials",
  GET_EDITORIALS: "EditorialFilter",
  USERS: "users",
  CREATENEWS: "createNews",
  CATEGORY: "categories",
  GET_CATEGORY: "CategoryFilter",
  GET_TAGFILTER: "TagFilter",
  USER_ROLE: "users-permissions/roles",
  PODCAST: "podcasts",
  REELS: "reels",

  POLLS: "polls",
  POLL_OPTION: "poll-options",
  CREATE_POLL: "createPolls",
  EDIT_POLL: "editPolls/",

  MAKE_VISIBLE: "polls/makeVisible",
  BANNERS: "bannners",
  GET_BANNERS: "filterBanner",
  GET_NJYAR: "NJayarFilter",
  GET_VIDYA: "VidyaFilter",
  GET_VIDYADATES: "VidyaFilterDates",
  WEB_STORIES: "webstories",
  ADD_TO_TRASH: "trash",
  UNTRASH: "unTrash",
  VIDYA_PRABHAADHAM: "vidyaprabhaadhams",
  NJAYAR_PRABHAADHAM: "njayarprabhaadhams",
  INSNAP: "in-snaps",
  GET_TRASHED: "getTrashedItems",
  PUT_UPDATE_USER: "updateUser/",
  GET_USERS: "getusers",

  GET_ONE_USER: "users/",

  GET_USERSEARCH: "usersearch",
  DELETE_USER: "deleteUser/",
  IDENTITY_CHECK: "epaper-users/identity/check",
  CHANGE_PASSWORD: "changePassword/",
  SUBCATEGORY: "subcategories",

  GET_ALL_LIBRARIES: "getAllLibraries",
  GET_ALL_SEARCHLIBRARY: "getAllSearchLibraries",
  GET_ALLNEWS_ID: "getAllNewsById/",
  ARTICLE: "articles",
  GET_ARTICLE: "ArticleFilter",
  HIGHLIGHTS: "highlights",
  UPDATE_NEWS: "updateNews",
  NJAYAR_MASTER: "njayarprabhaadham-masters",
  VIDYA_MASTER: "vidyaprabhaadham-masters",
  GET_INSNAP: "insnapFilter",
  GET_WEBSTRY: "WebStoriesFilter",
  GET_ADD: "advertisements",

  CREATE_LOGS: "logs",

  EPAPER_LIST: "filterEpaper", //POST
  EPAPER_DATE: "epaperdate", //POST
  EPAPER_ADD: "e-papers", // POST
  EPAPER_EDIT: "e-papers/", // PUT
  EPAPER_DELETE: "e-papers/", // DELETE
  EPAPER_PUBLISH: "e-papers", //PUT
  EPAPER_DETAILS: "e-papers/", //GET
  EPAPER_COMMON_PAGES: "applyCommonPages", // POST
  EPAPER_PROPAGATE_COMMON_COORDS: "propagateCommonCoords", // POST { date, commonId, image, coords }
  EPAPER_DETECT_ARTICLES: "epaper/detect-articles", // POST { imageUrl } -> { coords: [...] }

  QUIZZ_MASTER_LIST: "filterQuiz",
  QUIZZ_MASTER_ADD: "quiz-masters",
  QUIZZ_MASTER_EDIT: "quiz-masters/", //PUT
  QUIZZ_MASTER_DELETE: "quiz-masters/", // DELETE
  QUIZZ_MASTER_PUBLISH: "quiz-masters", //PUT
  QUIZZ_MASTER_DETAILS: "quiz-masters/", //GET
  QUIZZ_MASTER_ACTIVE: "quiz-masters/activate/", //GET

  QUIZZ_ITEM_LIST: "filterQuizItems",
  QUIZZ_ITEM_ADD: "addQuiz",
  QUIZZ_ITEM_EDIT: "editQuiz",
  QUIZZ_ITEM_DELETE: "quiz-items/",
  QUIZZ_ITEM_DETAILS: "quiz-items/",
  QUIZZ_ITEM_ACTIVATE: "quiz-item/activate-quiz/",
  QUIZZ_SELECT_WINNER: "quiz/select-winner",
  GET_EXCEL_DATA: "quiz-answers/getExcelData",
  QUIZZ_ANSWER_LIST: "filterQuizAnswers",

  ADVERTISEMENT_ADD: "advertisements",
  ADVERTISEMENT_EDIT: "advertisements/",
  ADVERTISEMENT_DELETE: "advertisements/",
  ADVERTISEMENT_LIST: "advertisements/filter",

  DYNAMIC_FORM_ADD: "forms",
  DYNAMIC_FORM_EDIT: "forms/",
  DYNAMIC_FORM_DETAILS: "forms/",
  DYNAMIC_FORM_LIST: "form/filter",
  DYNAMIC_FORM_RESPONSES: "form/getExcelData",

  // World Cup match predictions (module 32) — Strapi auto REST CRUD.
  MATCH_PREDICTIONS: "match-predictions",
  MATCH_PREDICTION_EDIT: "match-predictions/",

  FRAME_ADD: "frames",
  FRAME_EDIT: "frames/",
  FRAME_DETAILS: "frames/",
  FRAME_LIST: "frames",

  ELECTION_MASTER_ADD: "election-masters",
  ELECTION_MASTER_EDIT: "election-masters/",
  ELECTION_MASTER_DETAILS: "election-masters/",
  ELECTION_MASTER_LIST: "election-master/filter",

  ELECTION_ITEMS_ADD: "election-items",
  ELECTION_ITEMS_EDIT: "election-items/",
  ELECTION_ITEMS_DETAILS: "election-items/",
  ELECTION_ITEMS_LIST: "election-items/filter",

  // Election (new model: party, group, location, candidate, reports)
  ELECTION_PARTY_LIST: "election-parties/filter",
  ELECTION_PARTY_ADD: "election-parties",
  ELECTION_PARTY_EDIT: "election-parties/",
  ELECTION_PARTY_DETAILS: "election-parties/",

  ELECTION_GROUP_LIST: "election-groups/filter",
  ELECTION_GROUP_TREE: "election-groups/tree",
  ELECTION_GROUP_ADD: "election-groups",
  ELECTION_GROUP_EDIT: "election-groups/",
  ELECTION_GROUP_DETAILS: "election-groups/",

  ELECTION_LOCATION_LIST: "election-locations/filter",
  ELECTION_LOCATION_FULL: "election-locations/", // + :id/full
  ELECTION_LOCATION_ADD: "election-locations",
  ELECTION_LOCATION_EDIT: "election-locations/",
  ELECTION_LOCATION_DETAILS: "election-locations/",

  ELECTION_CANDIDATE_LIST: "election-candidates/filter",
  ELECTION_CANDIDATE_ADD: "election-candidates",
  ELECTION_CANDIDATE_EDIT: "election-candidates/",
  ELECTION_CANDIDATE_DETAILS: "election-candidates/",
  ELECTION_CANDIDATE_BATCH_VOTES: "election-candidates/batch-votes",

  ELECTION_REPORT_TALLY: "election-masters/seat-tally",
  ELECTION_REPORT_BY_LOCATION: "election-masters/report/by-location",
  ELECTION_REPORT_BY_PARTY: "election-masters/report/by-party",
  ELECTION_REPORT_PROGRESS: "election-masters/report/progress",
  ELECTION_REPORT_HOME_FEED: "election-masters/home-feed",

  SETTINGS_ADD: "settings",
  SETTINGS_EDIT: "settings/",
  SETTINGS_DETAILS: "settings/",
  SETTINGS_LIST: "settings",

  TAGS_LIST: "tags",
  TAGS_DELETE: "tags/",
  TAGS_LIST_ALL: "getTags",
  TAGS_ADD: "tag/create",

  // EPaper Users Management
  EPAPER_USERS_ADMIN_REGISTER: "epaper-users/admin-register",
  EPAPER_USERS_LIST: "epaper-users/list",
  EPAPER_USERS_EXPORT: "epaper-users/export",
  EPAPER_USERS_ADMIN_RESET_PASSWORD: "epaper-users/admin-reset-password",
  EPAPER_AGENTS_LIST: "epaper-users/agents",
  EPAPER_AGENTS_EXPORT: "epaper-users/agents/export",
  EPAPER_USER_SUBSCRIPTIONS: "epaper-users/", // + :id/subscriptions
  EPAPER_USERS_SUBSCRIPTIONS_LIST: "epaper-users/subscriptions",
  EPAPER_USER_TOGGLE_STATUS: "epaper-users/", // + :id/toggle-status
  EPAPER_USER_DELETE: "epaper-users/", // + :id/delete

  // EPaper User Reports
  EPAPER_USERS_REPORT_ZONE_WISE: "epaper-users/reports/zone-wise",
  EPAPER_USERS_REPORT_DISTRICT_WISE: "epaper-users/reports/district-wise",
  EPAPER_USERS_REPORT_DAILY: "epaper-users/reports/daily",
  EPAPER_USERS_REPORT_TABLE: "epaper-users/reports/table",

  // Subscription Plans
  SUBSCRIPTION_PLANS: "subscription-plans", // GET (list) + POST (create)
  SUBSCRIPTION_PLAN_ONE: "subscription-plans/", // + :id  — GET, PUT, DELETE
  SUBSCRIPTION_PLAN_ARCHIVE: "subscription-plans/", // + :id/archive  — PATCH
  SUBSCRIPTION_PLAN_ACTIVATE: "subscription-plans/", // + :id/activate — PATCH

  // E-Paper Settings (countries / zones / regions)
  EPAPER_SETTINGS_CONFIG: "epaper-settings/config", // GET — all countries + zones + regions
  EPAPER_SETTINGS_COUNTRIES: "epaper-settings/countries", // GET, POST; + /:id PUT, DELETE; + /:id/status PATCH
  EPAPER_SETTINGS_ZONES: "epaper-settings/zones", // GET (?country=), POST; + /:id PUT, DELETE; + /:id/status PATCH
  EPAPER_SETTINGS_REGIONS: "epaper-settings/regions", // GET, POST; + /:id PUT, DELETE; + /:id/status PATCH

  // Special Page Media Management
  SPECIAL_PAGE_MEDIA_LIST: "special-page-medias",
  SPECIAL_PAGE_MEDIA_PHOTOS: "special-page-medias/photos",
  SPECIAL_PAGE_MEDIA_VIDEOS: "special-page-medias/videos",
  SPECIAL_PAGE_MEDIA_ADD: "special-page-medias",
  SPECIAL_PAGE_MEDIA_EDIT: "special-page-medias/",
  SPECIAL_PAGE_MEDIA_DELETE: "special-page-medias/",
  GULF_VIDEO: "gulf-videos",

  // Release Notifications (module 25)
  RELEASE_NOTIFICATIONS_SEND: "release-notifications/send",
  RELEASE_NOTIFICATIONS_LIST: "release-notifications/list",
  RELEASE_NOTIFICATIONS_ONE: "release-notifications/", // + :id
};
